import React, {useEffect, useRef, useState} from "react"
import api from "../../../Services/api";
import {Typography} from "@mui/material";
import {ServiceCardType} from "../Types";
import { useTranslation } from 'react-i18next'

const { postPrintReceipt } = api.create();

interface PrintReceiptProps {
    serviceCard: ServiceCardType
    type: string
    onPrintDone: () => void
}

const PrintReceipt: React.FC<PrintReceiptProps> = ({serviceCard, type, onPrintDone}) => {
    const { t } = useTranslation()
    const [state, setState] = useState<string>(t('selfService.printing'))
    const hasRun = useRef(false); // Ref to track execution

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;

        async function print() {
            const response = await postPrintReceipt(serviceCard.token, type)
            if (response.ok) {
                setState('')
            } else {
                setState(t('selfService.printingError'))
            }
            onPrintDone()
        }

        print()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<Typography variant="h6" style={{height: 50}} gutterBottom>{state}</Typography>)
}

export default PrintReceipt
